var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06037 1.02039L0.323119 3.80463C0.234463 3.90446 0.167969 4.03758 0.167969 4.1596C0.167969 4.44801 0.367449 4.63658 0.644498 4.63658C0.788563 4.63658 0.888298 4.59221 0.988035 4.49238L2.1184 3.32766L2.99386 2.31822L2.93845 3.57169V10.5267C2.93845 10.8151 3.13793 11.0148 3.42606 11.0148C3.70311 11.0148 3.90259 10.8151 3.90259 10.5267V3.57169L3.85826 2.31822L4.72266 3.32766L5.85301 4.49238C5.94167 4.58112 6.05249 4.63658 6.18547 4.63658C6.46252 4.63658 6.662 4.43692 6.662 4.1596C6.662 4.03758 6.60659 3.90446 6.50685 3.80463L3.78069 1.02039C3.58122 0.809634 3.25984 0.798541 3.06037 1.02039ZM9.95333 10.8706L12.6795 8.07528C12.7792 7.98654 12.8346 7.84234 12.8346 7.72032C12.8346 7.43192 12.6352 7.24334 12.3581 7.24334C12.214 7.24334 12.1143 7.28771 12.0256 7.37646L10.8953 8.54118L10.0198 9.5506L10.0641 8.29713V1.34208C10.0641 1.06477 9.86467 0.854004 9.58762 0.854004C9.29949 0.854004 9.10003 1.06477 9.10003 1.34208V8.29713L9.15544 9.5506L8.27996 8.54118L7.14959 7.37646C7.06094 7.28771 6.95012 7.24334 6.81713 7.24334C6.54009 7.24334 6.34062 7.43192 6.34062 7.72032C6.34062 7.84234 6.39603 7.98654 6.49577 8.07528L9.22192 10.8706C9.43248 11.0814 9.74277 11.0925 9.95333 10.8706Z",
    fill: "#ffffff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/q.c5ca9ab6f411f11adb4112b6fb780d2c.svg";
export { ForwardRef as ReactComponent };